module.exports = __webpack_public_path__ + "img/avatar-default.75f62bee.svg";